uic-badge {
    direction: rtl;
    z-index: 0;
    display: flex;
    position: absolute;

    .uic-badge__content {
        direction: ltr;
        color: var(--uic-color-white);
        background-color: var(--uic-color-red2);
        display: block;
        width: fit-content;
        min-width: 13px;
        height: 18px;
        font-size: 12px;
        text-align: center;
        font-family: "Open Sans", sans-serif;
        font-weight: var(--uic-font-weight-semibold);
        padding: 1px 3px 0;
        z-index: 0;
        line-height: 18px;
    }
}
